<template >
  <b-container fluid>
    <b-row align="left">
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Estado del servicio:">
            <b-form-select :options="catalogoPadrones.tiposEstadoAgua" v-model="servicioAgua.estadoServicio"></b-form-select>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Inicio del servicio:">
            <b-form-datepicker type="date" v-model="servicioAgua.fechaInicio"></b-form-datepicker>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Tipo de Tarifa:">
            <b-form-select :options="catalogoPadrones.tiposTarifaAgua" v-model="servicioAgua.tarifa"></b-form-select>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Uso del servicio:">
            <b-form-select :options="catalogoPadrones.tiposUsoAgua" v-model="servicioAgua.tipoUso"></b-form-select>
          </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-row align-h="center" align="center" class="mt-5">
          <b-col><h4><b-icon icon="droplet-half"/> Suministro de Agua Potable</h4></b-col>
        </b-row>
        <b-row >
          <b-col cols="12"  v-if="!servicioAgua.tipoUso.includes('MIXTO')">
            <b-form-group :label="catalogoPadrones.labelFormTipoTomaAgua +':'">
                <b-form-select :options="tiposTomaAguaCalc" v-model="servicioAgua.tipoToma"></b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
        <b-row v-if="servicioAgua.tipoUso.includes('MIXTO') && catalogoPadrones.tiposTomaAguaUso0!=null && catalogoPadrones.tiposTomaAguaUso0.length>0">
          <b-col cols="4">
            <b-form-group :label="'No. Servicios tipo '+catalogoPadrones.tiposUsoAgua[0].toLowerCase()" >
              <b-form-input type="number" v-model="servicioAgua.numServs1"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group :label="catalogoPadrones.labelFormTipoTomaAgua+':'">
                <b-form-select :options="catalogoPadrones.tiposTomaAguaUso0" v-model="servicioAgua.tipoTomaServ1"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="servicioAgua.tipoUso.includes('MIXTO') && catalogoPadrones.tiposTomaAguaUso1!=null && catalogoPadrones.tiposTomaAguaUso1.length>0">
          <b-col cols="4">
            <b-form-group :label="'No. Servicios tipo '+catalogoPadrones.tiposUsoAgua[1].toLowerCase()" >
              <b-form-input type="number" v-model="servicioAgua.numServs2"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group :label="catalogoPadrones.labelFormTipoTomaAgua+':'">
                <b-form-select :options="catalogoPadrones.tiposTomaAguaUso1" v-model="servicioAgua.tipoTomaServ2"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="servicioAgua.tipoUso.includes('MIXTO') && catalogoPadrones.tiposTomaAguaUso2!=null && catalogoPadrones.tiposTomaAguaUso2.length>0">
          <b-col cols="4">
            <b-form-group :label="'No. Servicios tipo '+catalogoPadrones.tiposUsoAgua[1].toLowerCase()" >
              <b-form-input type="number" v-model="servicioAgua.numServs3"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group :label="catalogoPadrones.labelFormTipoTomaAgua+':'">
                <b-form-select :options="catalogoPadrones.tiposTomaAguaUso2" v-model="servicioAgua.tipoTomaServ3"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="servicioAgua.tipoUso.includes('MIXTO')  && catalogoPadrones.tiposTomaAguaUso3!=null && catalogoPadrones.tiposTomaAguaUso3.length>0">
          <b-col cols="4">
            <b-form-group :label="'No. Servicios tipo '+catalogoPadrones.tiposUsoAgua[3].toLowerCase()" >
              <b-form-input type="number" v-model="servicioAgua.numServs4"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group :label="catalogoPadrones.labelFormTipoTomaAgua+':'">
                <b-form-select :options="catalogoPadrones.tiposTomaAguaUso3" v-model="servicioAgua.tipoTomaServ4"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="12" sm="10" md="6" lg="6" xl="4"  >
        <b-form-group label="Fuente de suministro:">
          <b-form-select :options="[{value:true, text:'RED GENERAL DE AGUA'},{value:false, text:'FUENTE EXTERNA'}]" v-model="servicioAgua.tieneAgua"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <b-form-group label="Tipo de medición agua:">
            <b-form-select :options="catalogoPadrones.tiposCalculoAgua" v-model="servicioAgua.calculoAgua"></b-form-select>
          </b-form-group>
      </b-col>

      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <label v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">Serie/No. de Medidor:</label>
        <b-input-group  v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">          
          <b-input-group-prepend is-text><b-icon icon="upc-scan" style="cursor:pointer;" @click="obtenerInfoMedidor"></b-icon></b-input-group-prepend>
          <b-form-input :state="!$v.servicioAgua.numMedidor.$invalid" type="text" v-model="servicioAgua.numMedidor"></b-form-input>
        </b-input-group>
        
        <b-form-group :label="'Diámetro medidor (mm)'">
          <b-form-input type="number" v-model="servicioAgua.diametro"></b-form-input>
        </b-form-group>

      </b-col>

      <b-col cols="12" v-if="servicioAgua.calculoAgua.includes('MEDIDOR')" class="mt-2">
        <b-button variant="success" size="sm" @click="isShowModalConsumosAgua=true"><b-icon icon="list-check"/> Ver consumos de agua</b-button>
      </b-col>
      
      <b-col cols="12">
        <b-row align-h="center" align="center" class="mt-5">
            <b-col><h4><b-icon icon="grid3x2"/> Servicio de Drenaje</h4></b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <b-form-group label="Tiene Servicio de Drenaje:">
          <b-form-select :options="[{value:true, text:'SI'},{value:false, text:'NO'}]" v-model="servicioAgua.tieneDrenaje"></b-form-select>
        </b-form-group>
      </b-col>

     
       
      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <b-form-group :label="catalogoPadrones.labelFormTratamientoAgua+':'">
          <b-form-select :options="[{value:true, text:'SI'},{value:false, text:'NO'}]" v-model="servicioAgua.tieneTratamiento"></b-form-select>
        </b-form-group>
      </b-col>

      <b-col cols="12" sm="10" md="6" lg="6" xl="4" v-if="(servicioAgua.tieneDrenaje||servicioAgua.tieneTratamiento) && mpio.includes('aguaacolman')">
        <b-form-group label="Tipo de medición descarga:" >
            <b-form-select :options="catalogoPadrones.tiposCalculoAgua" v-model="servicioAgua.calculoDrenaje"></b-form-select>
          </b-form-group>
      </b-col>

      <b-col cols="12" sm="10" md="6" lg="6" xl="4" v-if="(servicioAgua.tieneDrenaje||servicioAgua.tieneTratamiento) && mpio.includes('aguaacolman')">
        <b-form-group label="Diámetro de descarga:" >
            <b-form-input type="number" v-model="servicioAgua.diametroDescarga"></b-form-input>
          </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-row align-h="center" align="center" class="mt-5">
            <b-col><h4><b-icon icon="geo-alt"/> Predio</h4></b-col>
        </b-row>
      </b-col>
      
      
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Grupo:">
            <b-form-select :options="catalogoPadrones.tiposGruposAgua" v-model="servicioAgua.grupo"></b-form-select>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Ruta:">
          <b-form-input :state="!$v.servicioAgua.ruta.$invalid" type="text" v-model="servicioAgua.ruta"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="Clasificación:">
            <b-form-select :options="catalogoPadrones.tiposClasesAgua" v-model="servicioAgua.clasificacion"></b-form-select>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="3">
        <b-form-group label="No Servicios:">
            <b-form-input v-model="servicioAgua.numServicios"></b-form-input>
          </b-form-group>
      </b-col>
      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <label>Clave Catastral:</label>
        <b-input-group>
          <b-input-group-prepend is-text><b-icon icon="house-door-fill" ></b-icon></b-input-group-prepend>
          <b-form-input :state="!$v.servicioAgua.claveCatastral.$invalid" type="text" v-model="servicioAgua.claveCatastral"></b-form-input>
        </b-input-group>
      </b-col>

      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <label>Información Inmueble:</label>
        <b-input-group>
          <b-input-group-prepend is-text><b-icon icon="geo-fill" ></b-icon></b-input-group-prepend>
          <b-form-input type="text" v-model="servicioAgua.infoPredio"></b-form-input>
        </b-input-group>
      </b-col>

      <b-col cols="12">
        <b-row align-h="center" align="center" class="mt-5">
            <b-col><h4><b-icon icon="bezier2"/> Derivaciones</h4></b-col>
        </b-row>
      </b-col>
      <b-col cols="12" v-if="servicioAgua.derivaciones !=null && servicioAgua.derivaciones.length>0">
        <b-row align-h="center" align="center">
          <b-col cols="4"><h6><b-icon icon="grid"/> Clave</h6> </b-col>
          <b-col cols="8"><h6><b-icon icon="person"/> Nombre</h6> </b-col>
        </b-row>
        <b-row v-for="derivacion in servicioAgua.derivaciones" :key="derivacion.clave" align-h="center" align="center" style="border-top: 1px solid gray:">
          <b-col cols="4" style="margin:0px; padding:0px;" > <b-form-input size="sm" disabled v-model="derivacion.clave"/></b-col>
          <b-col cols="8" style="margin:0px; padding:0px;"> <b-form-input size="sm" disabled v-model="derivacion.nombre"/></b-col>          
        </b-row>
      </b-col>
      <b-col cols="12" v-if="servicioAgua.derivaciones ==null || servicioAgua.derivaciones.length==0">
        <h6 style="color:gray;">No existen derivaciones registradas</h6>
      </b-col>

<!--       
      

      <b-col cols="12" sm="10" md="6" lg="6" xl="4">
        <b-form-group label="Número de Servicios Agua Potable:">
          <b-form-input :disabled="!servicioAgua.tieneAgua" :state="!$v.servicioAgua.numServicios.$invalid" type="number" v-model="servicioAgua.numServicios"></b-form-input>
        </b-form-group>
      </b-col> -->
      
    </b-row>

    <b-row align-h="between" align="between" class="mt-5 mb-4" >
      <b-col cols="11" sm="6"  class="mt-2">
        <b-button  variant="danger" @click="guardarCambiosContrib()">
          <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
          <strong v-if="isGuardandoDatosContrib"> Guardando . . .</strong>
          <strong v-if="!isGuardandoDatosContrib"> Guardar Cambios <b-icon  shift-v="-1" font-scale="1.3" icon="cloud-check-fill"/></strong>
        </b-button>
      </b-col>

      <b-col cols="11" sm="6"  class="mt-2" >

        <b-dropdown split variant="secondary" >
          <template #button-content>
            <b-spinner v-if="isGuardandoDatosContrib"></b-spinner>
            <strong v-if="isGuardandoDatosContrib"> Generando . . .</strong>
            <strong v-if="!isGuardandoDatosContrib"> Generar Documento <b-icon  shift-v="-1" font-scale="1.3" icon="file-earmark-text-fill"/></strong>
          </template>
          

          <b-dropdown-form v-if="contribuyenteActual!=null">
            <b-form-group >
                <b-form-input
                  v-model="folioDoc1"
                  placeholder="Folio Documento"
                ></b-form-input>
                <b-form-input
                  v-model="folioDoc2"
                  placeholder="Folio Pago"
                ></b-form-input>
            </b-form-group>
          </b-dropdown-form>
          <b-dropdown-item @click="generarDocumento(1, 'Contrato')"><b-icon icon="arrow-right-circle-fill"/> Contrato </b-dropdown-item>
          <b-dropdown-item @click="generarDocumento(1, 'Certificado de No Adeudo')"><b-icon icon="arrow-right-circle-fill"/> Certificado de No Adeudo</b-dropdown-item>
        </b-dropdown>

      </b-col>
    </b-row>
    
    <b-modal title="Lectura del consumo" scrollable  size="lg" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalLectura">
      <b-row>
        <b-col cols="12" class="mt-2 mb-2">
          <b>Fecha de lectura: </b>{{fechaRegistroConsumoModal}}
        </b-col>
        <b-col cols="12" class="mb-2">
          <b>Usuario: </b>{{usuarioConsumoModal}}
        </b-col>
        <b-col cols="12" class="mt-3 mb-5">
          <b-carousel>
            <b-carousel-slide  :img-src="archivoConsumoModal" ></b-carousel-slide>
          </b-carousel>
        </b-col>
        <b-col cols="12" class="mt-2 mb-5">
          <div class="mapouter" v-if="coordenadaConsumoModal != ''">
            <b-embed type="iframe" aspect="16by9" allowfullscreen :src="srcToEmbed+coordenadaConsumoModal+paramsToEmbed"></b-embed>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal title="Detalle del consumo" scrollable  size="lg"  hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalConsumo">
      <b-row>
        <b-col cols="12">
          <b-row align-h="center" align="center" class="mt-1 mb-2">
              <b-col><h4><b-icon icon="bezier2"/> Consumo Derivaciones</h4></b-col>
          </b-row>
        </b-col>
        <b-col cols="12" v-if="consumosDerivaciones !=null && consumosDerivaciones.length>0">

          <b-row align-h="center" align="center" v-if="consumosDerivaciones[0].consumoDerivaciones!=null">
            <b-col cols="12" style=" padding:0px;"> <h5 style="color:green">{{consumosDerivaciones[0].consumoDerivaciones}}</h5> </b-col>   
          </b-row>
          
          <b-row align-h="center" align="center">
            <b-col cols="4"><h6><b-icon icon="droplet-half"/> Consumo Calculado</h6> </b-col>
            <b-col cols="4"><h6><b-icon icon="clipboard-check"/> Consumo Registrado</h6> </b-col>
          </b-row>
          <b-row align-h="center" align="center" style="border-top: 1px solid gray:">
            <b-col cols="4" style=" padding:0px;"> <h5>{{consumosDerivaciones[0].consumoRaiz}}</h5></b-col>
            <b-col cols="4" style=" padding:0px;"> 
              <h5>{{consumosDerivaciones[0].consumoDiferenciaRaiz}} 
                <b-icon icon="info-circle-fill" font-scale=".9" style="cursor:pointer;" id="infoCDR"/>
              </h5>
              <b-tooltip target="infoCDR" triggers="click" placement="bottom">
                {{consumosDerivaciones[0].consumoDiferenciaDerivaciones}}
              </b-tooltip>
             </b-col>
          </b-row>

          <b-row align-h="center" align="center" ><b-col><b-button @click="actualizaConsumoDerivaciones" pill size="sm" variant="info">Actualizar Consumo </b-button></b-col></b-row>

          <b-row align-h="center" align="center" class="mt-3">
            <b-col cols="3"><h6><b-icon icon="grid"/> Clave</h6> </b-col>
            <b-col cols="6"><h6><b-icon icon="person"/> Nombre</h6> </b-col>
            <b-col cols="3"><h6><b-icon icon="person"/> Consumo</h6> </b-col>
          </b-row>
          <b-row v-for="derivacion in consumosDerivaciones" :key="derivacion.clave" align-h="center" align="center" style="border-top: 1px solid gray:">
            <b-col cols="3"  > <b-form-input size="sm" disabled v-model="derivacion.contrib.clave"/></b-col>
            <b-col cols="6" > <b-form-input size="sm" disabled v-model="derivacion.contrib.nombre"/></b-col>          
            <b-col cols="3" > <b-form-input size="sm" :state="derivacion.consumo.restaDerivacion" disabled v-model="derivacion.consumo.consumo"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" v-if="consumosDerivaciones ==null || consumosDerivaciones.length==0">
          <h6 style="color:gray;">No existen derivaciones registradas</h6>
        </b-col>
      </b-row>

    </b-modal>

    <b-modal title="Consumos de agua" scrollable  size="xl"  header-bg-variant="dark" header-text-variant="light" v-model="isShowModalConsumosAgua">
      <b-tabs content-class="mt-3" v-model="activeTabHConsumos"> 
        <b-tab title="Registro Actual" active>
          <b-row class="ml-1 mr-1">
            <b-col cols="12" >
              
              <b-row align-h="center" align="center">
                <b-col cols="1"><h5><b-icon icon="check2-square" @click="verTodosConsumos=!verTodosConsumos" /></h5></b-col>
                <b-col cols="2"><h6><b-icon icon="calendar3"/> Periodo</h6> </b-col>
                <b-col cols="2"><h6><b-icon icon="clipboard-check"/> Lectura</h6> </b-col>
                <b-col cols="2"><h6><b-icon icon="droplet-half"/> Consumo</h6> </b-col>
                <b-col cols="3"><h6><b-icon icon="list"/> Movimiento</h6> </b-col>
                <b-col cols="2"><h6><b-icon icon="list"/> Observación</h6> </b-col>
              </b-row>
              <b-row v-for="consumo in consumos" :key="consumo.id" align-h="center" align="center" style="border-top: 1px solid gray:">
                <b-col v-if="consumo.periodo.substring(0,4) >= servicioAgua.fechaInicio.substring(0,4) || verTodosConsumos">
                  <b-row align-h="center" align="center" >
                    <b-col cols="1" style="margin:0px; padding:0px;" > <b-form-checkbox size="lg" v-model="consumo.seleccionado" /></b-col>
                    <b-col cols="2" style="margin:0px; padding:0px;" v-if="!mpio.includes('huix')" > <b-form-input :state="consumo.cubierto" size="sm" disabled v-model="consumo.periodo"/></b-col>
                    <b-col cols="2" style="margin:0px; padding:0px;" v-if="mpio.includes('huix')" > <b-form-input  :state="consumo.cubierto" size="sm" disabled v-model="consumo.periodoB"/></b-col>
                    <b-col cols="2" style="margin:0px; padding:0px;"> 
                      
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="archive" style="cursor:pointer;" @click="showModalLectura(consumo.id)"/>
                        </b-input-group-prepend>
                        <b-form-input  size="sm" disabled v-model="consumo.lectura"/>
                      </b-input-group>
                    </b-col>
                    
                    
                    <b-col cols="2" style="margin:0px; padding:0px;"> 
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="droplet-half" style="cursor:pointer;" @click="showModalConsumo(consumo.id)"/>
                        </b-input-group-prepend>
                        <b-form-input v-model="consumo.consumo" disabled/>
                      </b-input-group>
                    </b-col>   
                    <b-col cols="3" style="margin:0px; padding:0px;"> <b-form-input size="sm" disabled v-model="consumo.info3"/></b-col>         
                    <b-col cols="2" style="margin:0px; padding:0px;"> 
                      <b-input-group size="sm" class="mb-2">
                        <b-input-group-prepend is-text>
                          <b-icon icon="info-circle-fill" font-scale=".9" style="cursor:pointer;" :id="consumo.periodo.replace(' ','-')"/>
                        </b-input-group-prepend>
                        <b-form-input size="sm" disabled v-model="consumo.info2" />
                      </b-input-group>
                      <b-tooltip :target="consumo.periodo.replace(' ','-')" triggers="click" placement="top">
                        {{consumo.info2}}
                      </b-tooltip>
                    </b-col>         
                  </b-row>
                </b-col>
              </b-row>   
              <b-row  align-h="right" align="end"><b-col><b-button @click="altaConsumoPeriodo" size="sm" pill variant="outline-secondary">Agregar periodo <b-icon icon="plus-circle-fill"/></b-button> <b-spinner variant="secondary" small v-if="isGuardandoDatosContrib" /></b-col></b-row>     
            </b-col>
          </b-row>
          
        </b-tab>
        <b-tab title="Histórico" @click="cargaHistoricoConsumos">
          <b-table :items="itemsHistoricoConsumos">
          </b-table>
        </b-tab>
      </b-tabs>
      <template #modal-footer="{ }">
        <b-row v-if="hayPeriodosSeleccionados && activeTabHConsumos==0" style="min-height:15%;">
          <b-col cols="12"><b>Registrar Consumo del periodo seleccionado</b></b-col>  
          <b-col cols="12"> 
            <b-form-group>
              <b-form-radio-group v-model="tipoRegistroConsumo" :options="['Por lectura','Por consumo']" />
            </b-form-group>
          </b-col>
          
          <b-col cols="12" md="6" class="mb-3">
            <b>Ingrese un valor númerico</b>
            <b-form-input type="number" :state="!$v.consumoLectura.$invalid" size="sm" v-model="consumoLectura" :placeholder="tipoRegistroConsumo=='Por lectura'?'Ingrese la lectura':'Ingrese el consumo'"></b-form-input>
          </b-col>
          <b-col cols="12" md="6"  >
            <b>Tipo</b>
            <b-form-select id="selectanomalias" size="sm"  v-model="tipoLectura" :options="tiposLectura" ></b-form-select>
          </b-col>
          
          <b-col cols="12" md="6" v-if="tipoLectura!=null">
            <b>Fecha de Lectura:</b>
            <b-form-datepicker   size="sm" v-model="fechaLecturaCM" ></b-form-datepicker>
          </b-col>

          <b-col cols="12" md="6" v-if="tipoLectura!=null && tipoLectura.includes('CAMBIO')">
            <b>Fecha de Instalación:</b>
            <b-form-datepicker   size="sm" v-model="fechaInstalacionCM" ></b-form-datepicker>
          </b-col>
         

          <b-col cols="12"  v-if="fotoMedidor==''">
            <b>Evidencia</b>
            <b-form-file  @change="saveFotoMedidorToB64" size="sm" accept="image/jpeg, image/png, image/jpg" placeholder="Ingrese la foto del medidor ..." drop-placeholder="Arrastre el archivo aquí..."  />
          </b-col>
          <b-col cols="12" md="7" v-if="fotoMedidor!=''">
            <b-img fluid  :src="fotoMedidor"></b-img><b-button v-if="fotoMedidor!=''" @click="fotoMedidor=''" variant="link">Borrar <b-icon icon="trash" font-scale=".9" shift-v="2"/></b-button>
          </b-col>
          
          <b-col cols="12"   class="mt-1">
            <b>Observación</b>
            <b-form-input type="text" size="sm" v-model="observacionLectura" placeholder="Ingrese una observación"></b-form-input>
          </b-col>
          
          <b-col cols="12" md="10" lg="7" class="mt-2">
            <b-button v-if="!isGuardandoDatosContrib" @click="registrarConsumo" size="sm" variant="success">Registrar <b-icon icon="arrow-right-circle"/></b-button>
            <b-spinner variant="success" small v-if="isGuardandoDatosContrib" />
          </b-col>
        </b-row>
        <b-row v-if="!hayPeriodosSeleccionados && activeTabHConsumos==0" >
          <b-col cols="12"><span style="color:gray;">Seleccione el periodo para registrar el consumo</span></b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- <b-modal title="Información del predio" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalInfoPredio">
      <b-row>
        <b-col cols="12" v-for="(dato, idx) in servicioAgua.infoPredio" :key="idx">
          <h6>{{dato}}</h6>
        </b-col>
      </b-row>
      <b-row align-h="center" align="center"><b-col class="mt-4 mb-4"><b-icon font-scale="3" style="color:green;" icon="geo-alt-fill"/></b-col></b-row>
    </b-modal> -->

    <b-modal size="lg" title="Información del medidor" hide-footer header-bg-variant="dark" header-text-variant="light" v-model="isShowModalInfoMedidor">
      <b-tabs content-class="mt-3">
        <b-tab title="Medidor" active>
          <b-row>
            <b-col cols="12" class="mt-3 mb-3"><h6><b-icon icon="upc-scan"/> Medidor {{servicioAgua.numMedidor}}</h6></b-col>
            
            <b-col cols="12" class="mt-2">
              <label v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">Tipo Medidor:</label>
              <b-input-group  v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">          
                <b-input-group-prepend is-text><b-icon icon="circle-square"></b-icon></b-input-group-prepend>
                <b-form-input  type="text" v-model="servicioAgua.infoMedidor"></b-form-input>
              </b-input-group>
            </b-col>

            <b-col cols="12" class="mt-2">
              <label v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">Fecha de Instalación:</label>
              <b-input-group  v-if="servicioAgua.calculoAgua.includes('MEDIDOR')">          
                <b-input-group-prepend is-text><b-icon icon="calendar2-check-fill"></b-icon></b-input-group-prepend>
                <b-form-datepicker type="date" v-model="servicioAgua.fechaMedidor"></b-form-datepicker>
              </b-input-group>
            </b-col>

          </b-row>
          <b-row v-if="catalogoPadrones.tieneAutogestionIUSA" class="mt-4">
            <b-col cols="12"><h6>Autogestión IUSA Pagos</h6></b-col>
            <b-col cols="12"  v-if="!servicioAgua.tieneAutogestionIusa"><b-button @click="vincularServicioIusa" size="sm" variant="success">Vincular servicio <b-icon icon="arrow-right-circle"/></b-button></b-col>
            <b-col cols="12"  v-if="servicioAgua.tieneAutogestionIusa"><h6>El servicio se encuentra autogestionado por IUSA</h6></b-col>
          </b-row>
        </b-tab>
        <b-tab title="Histórico" @click="cargaHistorico">
          <b-table :items="itemsHistoricoMedidores">
          </b-table>
        </b-tab>
        
      </b-tabs>
    </b-modal>

  </b-container>
</template>

<script>
  import { mapState} from 'vuex';
  import axios from 'axios';
  import { minLength, maxLength, required, between, numeric, decimal} from 'vuelidate/lib/validators';
  import { server, checkAuth, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
  import 'vue-loading-overlay/dist/vue-loading.css';
  //import panelEditarBaseFiscal from '@/components/padrones/panelEditarBaseFiscal.vue';

  export default {
    props: [ 'guardarCambiosContrib', 'isGuardandoDatosContrib', 'contribuyenteActual'],
    computed: {
      ...mapState({
        servicioAgua: state=> state.padrones.contribuyenteActual.basesFiscales[0].servicioAgua,
        consumos: state=> state.padrones.contribuyenteActual.basesFiscales[0].consumos,
        catalogoPadrones: state=> state.padrones.catalogoPadrones,
        token: state => state.login.token
      }),
      tiposTomaAguaCalc: function () {
        var idxTipoUso = 0;
        for(var idx=0; idx<this.catalogoPadrones.tiposUsoAgua.length; idx++){
          if(this.servicioAgua!=null && ( this.servicioAgua.tipoUso == this.catalogoPadrones.tiposUsoAgua[idx] )){
            idxTipoUso = idx;
            break;
          }
        }
        if(idxTipoUso==0){
          //this.servicioAgua.tipoToma = this.catalogoPadrones.tiposTomaAguaUso0[0];
          return this.catalogoPadrones.tiposTomaAguaUso0;
        }else if(idxTipoUso ==1){
          //this.servicioAgua.tipoToma = this.catalogoPadrones.tiposTomaAguaUso0[1];
          return this.catalogoPadrones.tiposTomaAguaUso1;
        }else if(idxTipoUso ==2){
          //this.servicioAgua.tipoToma = this.catalogoPadrones.tiposTomaAguaUso0[2];
          return this.catalogoPadrones.tiposTomaAguaUso2;
        }else{
          //this.servicioAgua.tipoToma = this.catalogoPadrones.tiposTomaAguaUso0[3];
          return this.catalogoPadrones.tiposTomaAguaUso3;
        }
      },
      hayPeriodosSeleccionados: function(){
        for(var idx=0; idx<this.consumos.length; idx++){
          if(this.consumos[idx].seleccionado){
            return true;
          }
        }
        return false;
      },
      mpio: function(){
        return this.$route.params.municipio;
      },
    },
    components:{
    },
    data() {
      return {
        
        fieldsTableBasesFiscales:[
                          {key: 'año', label: 'Año'},
                          {key: 'valorCatastral', label: 'Valor Catastral'},
                          {key: 'valorTerrenoPropio', label: 'Valor Terreno Propio'},
                          {key: 'valorTerrenoCommun', label: 'Valor Terreno Común'},
                          {key: 'valorConstruccionCommun', label: 'Valor Construcción Común'},
                          {key: 'valorConstruccionPropia', label: 'Valor Construcción Propia'},
                          {key: 'valorTerrenoCommun', label: 'Valor Construcción Común'},
                          {key: 'superficieTerrenoPropio', label: 'Superficie Terreno Propio'},
                          {key: 'superficieTerrenoCommun', label: 'Superficie Terreno Común'},
                          {key: 'superficieConstruccionPropia', label: 'Superficie Construcción Propia'},
                          {key: 'superficieConstruccionCommun', label: 'Superficie Construcción Común'},
                          {key: 'tipoUso', label: 'Tipo de Uso'},
                          {key: 'regimenPropiedad', label: 'Regimen de Propiedad'},
                          {key: 'acciones', label: 'Acciones'},
                        ],
        isConsultandoPago:false,
        isConsultandoMovimientos:false,
        isConsultandoExpediente:false,
        isConsultandoUbicacion:false,
        isVinculandoIusaPagos:false,
        isShowTablePagos: false,
        isShowTableMovimientos: false,
        isVisibleCollapsePagos:false,
        isVisibleCollapseMovs:false,
        isVisibleCollapseExpediente:false,
        isShowEditarBases:false,
        idxOfArrayBases:null,
        srcToEmbed: "https://maps.google.com/maps?q=",
        paramsToEmbed: "&t=k&z=20&ie=UTF8&iwloc=&output=embed",
        paginasExpedienteActual:null,
        isShowModalExpediente:false,

        fechaRegistroConsumoModal:"",
        archivoConsumoModal:"",
        usuarioConsumoModal:"",
        coordenadaConsumoModal:"",

        isShowModalLectura:false,
        isShowModalConsumo:false,
        isShowModalConsumosAgua:false,
        isShowModalInfoPredio:false,
        isShowModalInfoMedidor:false,
        folioDoc1:"",
        folioDoc2:"",
        
        verTodosConsumos:false,
        consumosDerivaciones:[],

        tipoRegistroConsumo:"Por lectura",
        consumoLectura:0.00,
        
        fechaInstalacionCM:null,
        fechaLecturaCM:null,

        fotoMedidor:"",
        coordenadaLectura:"",
        observacionLectura:"",
        tipoLectura:"REGISTRO NUEVA LECTURA",
        tiposLectura:[
                      'REGISTRO NUEVA LECTURA',
                      'CORRECCION DE LECTURA',
                      'CASA CERRADA',
                      'CASA DESHABITADA',
                      'LA MASCOTA NO PERMITIO LA TOMA DE LECTURA',
                      'LECTURA ILEGIBLE',
                      'MEDIDOR DESCOMPUESTO',
                      'MEDIDOR DETENIDO',
                      'MEDIDOR INVERTIDO',
                      'MEDIDOR ROTO',
                      'NO PERMITIERON LA TOMA DE LECTURA',
                      'SERVICIO SIN MEDIDOR',
                      'TERRENO BALDIO SIN TOMA',
                      'TOMA RESTRINGIDA',
                      'VUELTA DE MEDIDOR',
                      'CAMBIO DE MEDIDOR',
                      ],

        itemsHistoricoMedidores:[

        ],
        itemsHistoricoConsumos:[

        ],
        activeTabHConsumos:0,
        idConsumoActualConDerivaciones:-1

      }
    },
    methods: {
      showModalLectura(idConsumo){
        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.consultaConsumoAgua, null, this.token, {idContribuyente:this.contribuyenteActual.idContrib, idConsumo:idConsumo})
            
            ).then(res => {
              this.fechaRegistroConsumoModal=res.data.fechaLectura;
              this.archivoConsumoModal=res.data.archivo;
              this.usuarioConsumoModal=res.data.usuario;
              this.coordenadaConsumoModal=res.data.coordenada,
              this.isShowModalLectura=true;
              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.consultaConsumoAgua, this.$router, this.$store);
            })
        }

      },
      showModalConsumo(idConsumo){
        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          this.idConsumoActualConDerivaciones=idConsumo;
          axios(
            getPostConfig(server.consultaConsumoDerivaciones, null, this.token, {idContribuyente:this.contribuyenteActual.idContrib, idConsumo:idConsumo})
            
            ).then(res => {
              this.consumosDerivaciones = res.data;
              this.isShowModalConsumo=true;
              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.consultaConsumoDerivaciones, this.$router, this.$store);
            })
        }

      },  
      actualizaConsumoDerivaciones(){
        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          this.isShowModalConsumo = false;
          axios(
            getPostConfig(server.actualizaconsumoderivaciones, null, this.token, {idContribuyente:this.contribuyenteActual.idContrib, idConsumo:this.idConsumoActualConDerivaciones})
            
            ).then(res => {
              this.$store.commit("updateConsumosContribuyente", res.data);
              this.isGuardandoDatosContrib=false;
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.consultaConsumoDerivaciones, this.$router, this.$store);
            })
        }

      },      
      showModalEditarBases(idxOfTableBases){
        this.idxOfArrayBases = idxOfTableBases;
        this.isShowEditarBases = true;
      },/*
      guardarCambiosContrib(){
        var datosContribuyente = {clave: this.contribuyenteActual.clave, clave2: this.contribuyenteActual.clave2, correo: this.contribuyenteActual.correo, curp: this.contribuyenteActual.curp, direccion: this.contribuyenteActual.direccion, 
                                  idContrib: this.contribuyenteActual.idContrib, isBloquearCobro: this.contribuyenteActual.isBloquearCobro, isNotificado: this.contribuyenteActual.isNotificado, 
                                  noActos: this.contribuyenteActual.noActos, nombre: this.contribuyenteActual.nombre, obs: this.contribuyenteActual.obs, rfc: this.contribuyenteActual.rfc, 
                                  telefono: this.contribuyenteActual.telefono, tipoContribuyente: this.contribuyenteActual.tipoContribuyente, ubicacion: this.contribuyenteActual.ubicacion, 
                                  coordenada: this.contribuyenteActual.coordenada,
                                  basesFiscales: this.contribuyenteActual.basesFiscales, fundamento: this.contribuyenteActual.fundamento};
                                  

        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editarContribuyente, datosContribuyente, this.token, {tipoPadron:this.contribuyenteActual.tipoContribuyente.substr(0, 1), clave:this.contribuyenteActual.clave})
            
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.isGuardandoDatosContrib=false;
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editarContribuyente, this.$router, this.$store);
            })
        }
      },*/
      consultarPagosContrib(){
        if(!this.isConsultandoPago && !this.isVisibleCollapsePagos && checkAuth(this.$router, this.$store)){
          this.isConsultandoPago=true;
          axios(
            getGetConfig(server.pagosContribuyente, null, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updatePagosContribuyenteActual", res.data);
              this.isShowTablePagos = true;
              this.isConsultandoPago=false;
            }).catch(err => {
                this.isConsultandoPago=false;
                handledError(err, server.pagosContribuyente, this.$router, this.$store);
            })
        }
      },
      consultarMovimientosContrib(){
        if(!this.isConsultandoMovimientos && !this.isVisibleCollapseMovs && checkAuth(this.$router, this.$store)){
          this.isConsultandoMovimientos=true;
          axios(
            getGetConfig(server.movsContribuyente, null, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updateMovimientosContribuyenteActual", res.data);
              this.isShowTableMovimientos = true;
              this.isConsultandoMovimientos=false;
            }).catch(err => {
                this.isConsultandoMovimientos=false;
                handledError(err, server.movsContribuyente, this.$router, this.$store);
            })
        }
      },
      consultarExpedientesContrib(){
        if(!this.isConsultandoExpediente && checkAuth(this.$router, this.$store) && !this.isVisibleCollapseExpediente){
          this.isConsultandoExpediente=true;
          axios(
            getGetConfig(server.expedientesContribuyente, {}, this.token, {clave: this.clave, tipoPadron: this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updateExpedientesContribuyenteActual", res.data);
              this.isConsultandoExpediente=false;
          }).catch(err => {
              this.isConsultandoExpediente=false;
              handledError(err, server.expedientesContribuyente, this.$router, this.$store);
          })
        }
      },
      mostrarModalPaginasExpediente(expediente){
        this.paginasExpedienteActual = expediente.paginas;
        this.isShowModalExpediente = true;
      },
      consultarUbicacionContrib(){
        if(!this.isConsultandoUbicacion & checkAuth(this.$router, this.$store)){
          this.isConsultandoUbicacion=true;
          axios(
            getPostConfig(server.ubicacionContribuyente, {}, this.token)
            ).then(res => {
              alert(res);
              //this.$store.commit("updateContribuyentes", res);
              this.isConsultandoUbicacion=false;
          }).catch(err => {
              this.isConsultandoUbicacion=false;
              handledError(err, server.ubicacionContribuyente, this.$router, this.$store);
          })
        }
      },
      obtenerInfoPredio(){
      /*
        if(checkAuth(this.$router, this.$store)){
          axios(
            getGetConfig(server.consultaPredio, {}, this.token, {claveCat:this.servicioAgua.claveCatastral})
            ).then(res => {
              this.servicioAgua.infoPredio = res.data;
              this.isShowModalInfoPredio = true;
          }).catch(err => {
              handledError(err, server.consultaPredio, this.$router, this.$store);
          })
        }*/
      },
      obtenerInfoMedidor(){
        
        //this.servicioAgua.infoMedidor = [];
        this.isShowModalInfoMedidor = true;
          
      },
      vincularServicioIusa(){
        if(!this.isVinculandoIusaPagos & checkAuth(this.$router, this.$store)){
          this.isVinculandoIusaPagos=true;
          axios(
            getPostConfig(server.vinculaAutogestionIusa, {}, this.token, {idContribuyente: this.contribuyenteActual.idContrib})
            ).then(res => {
              alert(res.data);
              //this.$store.commit("updateContribuyentes", res);
              this.isVinculandoIusaPagos=false;
          }).catch(err => {
              this.isVinculandoIusaPagos=false;
              handledError(err, server.vinculaAutogestionIusa, this.$router, this.$store);
          })
        }
        
      },
      saveFotoMedidorToB64(evt){
         //this.$store.commit("updateIsWorking", true);
        var f = evt.target.files[0];
        var reader = new FileReader();
        //Creamos una refrencia local al objeto this para poder acceder desde las funciones anidadas a los objetos cliente, token .. etc
        var thisObject = this;
        reader.onload = function (e) {
            var img = document.createElement("img");
            img.onload = function () {
                var MAX_WIDTH = 465;
                var MAX_HEIGHT = 465;

                var width = img.width;
                var height = img.height;

                // Change the resizing logic
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                    }
                }
                // Dynamically create a canvas element
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                // var canvas = document.getElementById("canvas");
                var ctx = canvas.getContext("2d");

                // Actual resizing
                ctx.drawImage(img, 0, 0, width, height);

                // Show resized image in preview element
                var dataurl = canvas.toDataURL(f.type);
                thisObject.fotoMedidor = dataurl;
            }
            img.src = e.target.result;
        }
        reader.onerror = function(error){
          alert("error al cargar archivo"+error);
        };
        reader.readAsDataURL(f);

        //Se guarda la ubicacion
        navigator.geolocation.getCurrentPosition(
          function success(pos) {
            const crd = pos.coords;
            thisObject.coordenadaLectura=crd.latitude+','+crd.longitude
          }, 
          function error(err) {
            alert(`ERROR(${err.code}): ${err.message}`);
          }, 
           {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          });

      },
      registrarConsumo(){
        var idContrib= this.contribuyenteActual.idContrib;
        var consumosSel=[];
        for(var consumo in this.consumos){
          if(this.consumos[consumo].seleccionado){
            consumosSel.push(this.consumos[consumo]);
          }
        }
        var registro = {
          porConsumo : (this.tipoRegistroConsumo == 'Por consumo'),
          consumoLectura: this.consumoLectura,
          lectura:this.consumoLectura,
          archivo:this.fotoMedidor,
          coordenada:this.coordenadaLectura,
          observacion:this.observacionLectura,
          anomalia:this.tipoLectura,
          consumos: consumosSel,
          fechaInstalacionCM:this.fechaInstalacionCM,
          fechaLecturaCM:this.fechaLecturaCM,
        };
                                  

        if(!this.$v.consumoLectura.$invalid && !this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.editarConsumosAgua, registro, this.token, {idContribuyente:idContrib})
            
            ).then(res => {
              this.$store.commit("updateConsumosContribuyente", res.data);
              this.isGuardandoDatosContrib=false;
              this.consumoLectura = 0.00;
              this.fotoMedidor = '';
              this.coordenadaLectura = '';
              alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.editarConsumosAgua, this.$router, this.$store);
            })
        }
      },
      altaConsumoPeriodo(){
        if(!this.isGuardandoDatosContrib && !this.isEliminandoContrib && checkAuth(this.$router, this.$store)){
          this.isGuardandoDatosContrib=true;
          axios(
            getPostConfig(server.altaconsumoagua, null, this.token, {idContribuyente:this.contribuyenteActual.idContrib, idServicioAgua:this.servicioAgua.idServicioAgua})
            ).then(res => {
              this.$store.commit("updateConsumosContribuyente", res.data);
              this.isGuardandoDatosContrib=false;
              //alert("Se ha actualizado la información de contribuyente.");
            }).catch(err => {
              this.isGuardandoDatosContrib=false;
              handledError(err, server.altaconsumoagua, this.$router, this.$store);
            })
        }
        
      },
      cargaHistorico(){
        if(!this.isConsultandoMovimientos && !this.isVisibleCollapseMovs && checkAuth(this.$router, this.$store)){
          this.isConsultandoMovimientos=true;
          axios(
            getGetConfig(server.movsMedidores, null, this.token, {clave: this.contribuyenteActual.clave})
            ).then(res => {
              this.itemsHistoricoMedidores= res.data;
              this.isConsultandoMovimientos=false;
            }).catch(err => {
                this.isConsultandoMovimientos=false;
                handledError(err, server.movsContribuyente, this.$router, this.$store);
            })
        }
      },
      cargaHistoricoConsumos(){
        if(!this.isConsultandoMovimientos && !this.isVisibleCollapseMovs && checkAuth(this.$router, this.$store)){
          this.isConsultandoMovimientos=true;
          axios(
            getGetConfig(server.movsConsumos, null, this.token, {clave: this.contribuyenteActual.clave})
            ).then(res => {
              this.itemsHistoricoConsumos= res.data;
              this.isConsultandoMovimientos=false;
            }).catch(err => {
                this.isConsultandoMovimientos=false;
                handledError(err, server.movsContribuyente, this.$router, this.$store);
            })
        }
      }
    },
    validations: {
      consumoLectura:{
        required,
        decimal,
        between: between(0, 1000000000)
      },
      servicioAgua:{
        claveCatastral:{
          minLength: minLength(1),
          maxLength: maxLength(16)
        },
        ruta:{
          minLength: minLength(1),
          maxLength: maxLength(30)
        },
        numMedidor:{
          minLength: minLength(1),
          maxLength: maxLength(30)
        },
        numServicios:{
          required,
          numeric,
          between: between(0, 100000)
        },
      }
    }
  }
</script>
<style>
div.error    {color: red;}
</style>